import axios from 'axios';




export default  axios.create({
    baseURL: 'https://couchette.in/api/user/'
})
